import { render, staticRenderFns } from "./ListOfAcceptors.vue?vue&type=template&id=0fa81914"
import script from "./ListOfAcceptors.vue?vue&type=script&lang=js"
export * from "./ListOfAcceptors.vue?vue&type=script&lang=js"
import style0 from "./ListOfAcceptors.vue?vue&type=style&index=0&id=0fa81914&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports